module.exports = __webpack_public_path__ + "img/feature_buy_th.f10fbc78.png";